import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";


@Pipe({
	name: "filetypeIcon",
	standalone: true
})
export class GetFiletypeIconPipe implements PipeTransform {

	constructor(public sanitizer: DomSanitizer) {}

	transform(mimeType: string, sanitizeMe: boolean = true): any {
		const folder = "./assets/placeholder/";

		let icon = folder + "file.svg";

		switch (mimeType) {
			case "image/jpeg":
			case "image/png":
			case "image/gif":
				icon = folder + "image.svg";
				break;

			case "video/mp4":
			case "video/webm":
			case "video/ogg":
			case "video/mpeg":
				icon = folder + "video.svg";
				break;

			case "application/pdf":
				icon = folder + "pdf.svg";
				break;

			case "application/vnd.microsoft.portable-executable ":
				icon = folder + "exe.svg";
				break;

			default:
				icon = folder + "file.svg";
				break;
		}

		if (sanitizeMe) {
			return this.sanitizer.bypassSecurityTrustUrl(icon);
		} else {
			return icon;
		}
	}

}
